import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, darkGray, denim, white} from '/theme/color/on.color';
import {codGray, mineShaft} from '/theme/color/secondary.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  divider: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
    marginVertical: indent * 0.75,
  },
  link: {
    color: denim,
    fontWeight: '600',
  },
  headerContainer: {
    marginBottom: 10,
    flexDirection: 'row',
  },
  headerContainerLargeFont: {
    flexWrap: 'wrap',
    alignItems: 'flex-start',
  },
  headerText: {
    flex: 1,
    color: codGray,
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  optaText: {
    fontSize: 16,
    ...getFontFamily('bold'),
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  viaText: {
    fontSize: 16,
    ...getFontFamily('regular'),
  },
  // @ts-expect-error TS(2322): Type '{ fontFamily: string; fontWeight: string | u... Remove this comment to see the full error message
  titleText: {
    fontSize: 16,
    ...getFontFamily('bold'),
  },
  sideText: {
    color: mineShaft,
  },
  sideTextLargeFont: {
    width: '100%',
    marginTop: indent * 0.15,
  },
  incentiveTripContent: {
    borderRadius: 12,
    borderWidth: 1,
    borderColor: cloudLight,
    backgroundColor: white,
    paddingLeft: 16,
    paddingRight: 12,
    paddingVertical: 16,
    marginRight: 0,
    alignSelf: 'stretch',
    marginBottom: 15,
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  heading: {
    paddingBottom: indent * 0.25,
    alignItems: 'center',
  },
  subHeading: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    flexWrap: 'wrap',
  },
  requirements: {
    alignSelf: 'flex-end',
  },
  path: {
    flex: 1,
    fontSize: 12,
    alignSelf: 'flex-end',
    color: darkGray,
    marginLeft: indent * 0.5,
  },
  daysLeft: {
    flex: 1,
    fontSize: 12,
    alignSelf: 'flex-end',
    color: darkGray,
    marginLeft: indent * 0.5,
  },
});
